import { type FC } from 'react'

import { Navigate, useParams } from '@tanstack/react-router'

import { isAdminPromotionType } from './isAdminPromotionType'
import { PromotionCreateFormPage } from './PromotionCreateFormPage'

export interface AdminPromotionCreateFormPageProps {
  onDirtyChange?: (isDirty: boolean) => void
}

export const AdminPromotionCreateFormPage: FC<AdminPromotionCreateFormPageProps> = ({ onDirtyChange }) => {
  const { initiativeId, type } = useParams({ from: '/promotions/$initiativeId/national/create/$type' })

  if (!isAdminPromotionType(type)) {
    return <Navigate from="/promotions/$initiativeId/national/create/$type" to="../.." replace />
  }

  return (
    <PromotionCreateFormPage
      initiativeId={initiativeId}
      metadata={{ initiativeId, type }}
      type={type}
      onDirtyChange={onDirtyChange}
    />
  )
}
